import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SessionStorageService } from '../../../core/services/session-storage/session-storage.service';
import { SnackbarService } from '../../../shared/services/snackbar/snackbar.service';
import { Router } from '@angular/router';
import { ConfirmPopupComponent } from '../new-rep-application/confirm-popup/confirm-popup.component';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OnboardingAssessmentService } from '../onboarding-assessment/onboarding-assessment-services/onboarding-assessment.service';
import { OnboardingAssesmentModel } from '../onboarding-assessment/onboarding-assesment-models/onboarding-assesment-model.model';
import { OnboardingAssesment } from '../onboarding-assessment/onboarding-assesment-interface/onboarding-assesment.interface';
import { DsuAssessmentModel } from './dsu-assessment-models/dsu-assessment.models';
import { DsuAssessmentService } from './dsu-assessment-service/dsu-assessment.service';
import { HttpStatusCode } from 'axios';
import { viewdsuAssessment } from './dsu-assessment-interface/dsu-assessment.interface';
import { AgentOnboardingService } from '../agent-onboarding/agent-onboarding-service/agent-onboarding.service';
import { NewRepChecklistService } from '../new-rep-checklist/new-rep-checklist-services/new-rep-checklist.service';
import { getChecklistItems } from '../new-rep-checklist/new-rep-checklist-interfaces/save-new-rep-checklist.interface';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DocumentPreviewOverlayDirective } from '../../../shared/directives/document-preview-overlay/document-preview-overlay.directive';

@Component({
  selector: 'app-dsu-assessment',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatIcon,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    DocumentPreviewOverlayDirective
  ],
  templateUrl: './dsu-assessment.component.html',
  styleUrl: './dsu-assessment.component.scss'
})
export class DsuAssessmentComponent implements OnInit {

  private fb = inject(FormBuilder);
  private readonly matDialog = inject(MatDialog);
  readonly message = ' This field is required.';
  private sanitizer = inject(DomSanitizer);
  private sessionStorageService = inject(SessionStorageService);
  private returnbyroleService = inject(AgentOnboardingService);
  private dsuAssessmentService = inject(DsuAssessmentService);
  private documentUploadService = inject(OnboardingAssessmentService);
  private newRepChecklistService = inject(NewRepChecklistService);
  private snackBarService = inject(SnackbarService);
  private router = inject(Router);
  setSprinner = signal(false);
  submitted = signal(false);
  errormessage1!: string;
  errormessage2!: string;
  designation!: string;

  data = history.state;
  viewId!: number;
  viewdsuAssessment!: viewdsuAssessment;
  isReadOnly = signal(false);
  iseditable = signal(false);
  protected currentUserRole: string = "";
  protected status: string = "";
  protected getchecklistItems: getChecklistItems[] = [];
  checklistinvalidflag = signal(false);
  role!: string;

  /** Prefix used for the dynamically added "Other Attachments" controls. */
  readonly otherAttachmentPrefix = 'otherAttachment';
  /** Document type sent for every "Other Attachments" upload - the row index goes in responseValue. */
  readonly otherAttachmentDescription = 'OtherAttachments';
  /** Control keys of the rendered "Other Attachments" rows, e.g. ['otherAttachment1', 'otherAttachment2']. */
  otherAttachmentKeys: string[] = [];
  private otherAttachmentSeq = 0;
  /** The "Other Attachments" rows of this application's uploaded documents. */
  private otherAttachmentDocuments: OnboardingAssesment[] = [];

  public dsuassessmentForm: FormGroup = this.fb.group({
    name: [''],
    manager: [''],
    initialremarks: [''],
    finalremarks: [''],
    corporateMailAddress: [''],
    initialdeclarationaccepted: ['', [Validators.required]],
    initialdsuname: [''],
    initialdate: [''],
    finaldeclarationaccepted: ['', [Validators.required]],
    finaldsuname: [''],
    finaldate: [''],


  });

  selectedDocument!: SafeResourceUrl;
  isPdf = false;
  selectedItemFile!: string;
  currentFileName!: string;

  readonly MIN_ZOOM = 0.5;
  readonly MAX_ZOOM = 3;
  private readonly ZOOM_STEP = 0.25;
  zoomLevel = 1;

  ngOnInit(): void {
    this.currentUserRole = this.sessionStorageService.getCurrentUserRole();
    this.viewId = this.data.id;
    this.status = this.data.status;
    this.designation = this.data.designation;
    this.isReadOnly.set(this.data.isReadOnly);
    this.iseditable.set(this.data.iseditable);
    if (this.designation == 'Introducer - Individual') {
      this.role = 'INDIVIDUAL';
    } else {
      this.role = 'CORPORATE';
    }
    this.viewDsuAssessment();
    this.getChecklistItems();
    this.loadOtherAttachments();
    if ((this.currentUserRole == 'DSU') && this.iseditable()) {
      this.isReadOnly.set(false);
    }
    if (this.isReadOnly() == true) {
      this.dsuassessmentForm?.disable();
    } else {
      this.dsuassessmentForm?.enable();
    }
  }

  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }

  async changevalue(formControlName: string) {
    if (formControlName == 'initialdeclarationaccepted') {
      let value = this.dsuassessmentForm.get('initialdeclarationaccepted')?.value;
      if (value) {
        this.dsuassessmentForm.patchValue({
          initialdsuname: this.sessionStorageService.getCurrentUserPersonName(),
          initialdate: this.getToday()
        });
        this.errormessage1 = '';
      } else {
        this.dsuassessmentForm.patchValue({
          initialdsuname: null,
          initialdate: null
        });
        if (value == false) {
          this.dsuassessmentForm.get('initialdeclarationaccepted')?.markAllAsTouched();
        }
      }
    } else {
      let value = this.dsuassessmentForm.get('finaldeclarationaccepted')?.value;
      if (value) {
        this.dsuassessmentForm.patchValue({
          finaldsuname: this.sessionStorageService.getCurrentUserPersonName(),
          finaldate: this.getToday()
        });
        this.errormessage2 = '';
      } else {
        this.dsuassessmentForm.patchValue({
          finaldsuname: null,
          finaldate: null
        });
        if (value == false) {
          this.dsuassessmentForm.get('finaldeclarationaccepted')?.markAllAsTouched();
        }
      }
    }
  }

  // ---------- Other Attachments ----------

  /**
   * Fetches this application's uploaded documents and rebuilds the
   * "Other Attachments" rows from the 'OtherAttachments' entries.
   */
  async loadOtherAttachments(): Promise<void> {
    const responseData = await this.documentUploadService
      .viewDsudocumentslist(this.viewId)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    if (responseData.status === HttpStatusCode.Ok) {
      const allDocuments: OnboardingAssesment[] = responseData.data.responsedata ?? [];
      this.otherAttachmentDocuments = allDocuments.filter(
        item => this.otherAttachmentIndexOf(item) !== null
      );
    }

    this.buildOtherAttachments();
  }

  /** The row index sent as responseValue for an "Other Attachments" control key. */
  private otherAttachmentIndex(key: string): string {
    return key.slice(this.otherAttachmentPrefix.length);
  }

  /** Row index of a control key as a number, for matching and ordering. */
  private otherAttachmentRow(key: string): number {
    return Number(this.otherAttachmentIndex(key));
  }

  /**
   * Row index an uploaded document belongs to, or null when it isn't an "Other
   * Attachments" row. Uploads carry 'OtherAttachments' as the document type with
   * the index in responseValue; rows saved before that change kept the index in
   * the document type itself, so both shapes are recognised here. The index is
   * read as a number so a row is still matched when the API echoes it back in a
   * different form (' 2', 2) than the one that was sent.
   */
  private otherAttachmentIndexOf(item: OnboardingAssesment | undefined): number | null {
    const docType = item?.onboardingDocumentType ?? '';
    const raw = docType === this.otherAttachmentDescription
      ? String(item?.responseValue ?? '').trim()
      : docType.startsWith(this.otherAttachmentPrefix)
        ? docType.slice(this.otherAttachmentPrefix.length)
        : '';

    const row = Number(raw);
    return raw !== '' && Number.isFinite(row) ? row : null;
  }

  /** Locates the uploaded document behind an "Other Attachments" row, matched on its index. */
  private findOtherAttachmentDocument(key: string): OnboardingAssesment | undefined {
    const row = this.otherAttachmentRow(key);
    return this.otherAttachmentDocuments.find(item => this.otherAttachmentIndexOf(item) === row);
  }

  /**
   * Restores any previously uploaded "Other Attachments" and always keeps at
   * least one empty row. Safe to call repeatedly (loadOtherAttachments() runs
   * again after every upload) - restoreOtherAttachment() only adds unseen
   * controls.
   */
  private buildOtherAttachments(): void {
    this.otherAttachmentDocuments.forEach(item => {
      const index = this.otherAttachmentIndexOf(item);
      if (index !== null) {
        this.restoreOtherAttachment(`${this.otherAttachmentPrefix}${index}`, item.fileName);
      }
    });

    if (this.otherAttachmentKeys.length === 0) {
      this.addOtherAttachment();
    }

    // The API lists the documents in its own order, so the rows are put back in row
    // order here. Left unsorted the fields swap places on every fetch, and because
    // the template hangs the remove button off every row but the first and the add
    // button off the last, those buttons end up on whichever rows came back first.
    this.otherAttachmentKeys.sort((a, b) => this.otherAttachmentRow(a) - this.otherAttachmentRow(b));
  }

  private restoreOtherAttachment(key: string, fileName: string): void {
    if (!this.otherAttachmentKeys.includes(key)) {
      this.dsuassessmentForm.addControl(key, this.fb.control([null]));
      this.dsuassessmentForm.addControl(`${key}fileName`, this.fb.control(''));
      this.otherAttachmentKeys.push(key);

      const seq = Number(key.slice(this.otherAttachmentPrefix.length));
      if (!Number.isNaN(seq) && seq > this.otherAttachmentSeq) {
        this.otherAttachmentSeq = seq;
      }
    }
    this.dsuassessmentForm.get(`${key}fileName`)?.setValue(fileName);
  }

  /** Duplicates the "Other Attachments" field so another file can be attached. */
  addOtherAttachment(): void {
    const key = `${this.otherAttachmentPrefix}${++this.otherAttachmentSeq}`;
    this.dsuassessmentForm.addControl(key, this.fb.control([null]));
    this.dsuassessmentForm.addControl(`${key}fileName`, this.fb.control(''));
    this.otherAttachmentKeys.push(key);
  }

  /** Removes a duplicated "Other Attachments" row, deleting its uploaded file first when there is one. */
  removeOtherAttachment(key: string): void {
    if (!this.dsuassessmentForm.get(`${key}fileName`)?.value) {
      this.dropOtherAttachment(key);
      return;
    }

    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to remove the attachement?',
        hidecancel: false,
      }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result?.data === true) {
        await this.deleteOtherAttachmentDocument(key);
        this.dropOtherAttachment(key);
      }
    });
  }

  /** Clears the uploaded file but keeps the "Other Attachments" field on screen. */
  removeOtherAttachmentFile(key: string): void {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to remove the attachement?',
        hidecancel: false,
      }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result?.data !== true) {
        return;
      }

      await this.deleteOtherAttachmentDocument(key);

      this.dsuassessmentForm.get(key)?.reset();
      this.dsuassessmentForm.get(`${key}fileName`)?.reset();
      const fileInput = document.getElementById(`${key}fileName`) as HTMLInputElement;
      if (fileInput) {
        fileInput.value = '';
      }
      this.dsuassessmentForm.get(`${key}fileName`)?.markAsTouched();
      this.dsuassessmentForm.get(`${key}fileName`)?.updateValueAndValidity();
    });
  }

  private async deleteOtherAttachmentDocument(key: string): Promise<void> {
    const match = this.findOtherAttachmentDocument(key);
    if (!match?.id) {
      return;
    }

    const data = {
      onboardingId: this.viewId,
      docTypeId: match.docTypeId,
      id: match.id
    };

    await this.documentUploadService
      .deleteonbordingdocument(data)
      .then((response) => JSON.parse(response))
      .catch((error) => {
        // console.error(error);
        return error;
      });

    this.otherAttachmentDocuments = this.otherAttachmentDocuments.filter(item => item !== match);
  }

  private dropOtherAttachment(key: string): void {
    this.dsuassessmentForm.removeControl(key);
    this.dsuassessmentForm.removeControl(`${key}fileName`);
    this.otherAttachmentKeys = this.otherAttachmentKeys.filter(item => item !== key);
  }

  onOtherAttachmentFileChange(event: any, key: string): void {
    const file = event.target.files?.[0];
    const fileControl = this.dsuassessmentForm.get(`${key}fileName`);

    this.dsuassessmentForm.patchValue({
      [key]: file,
      [`${key}fileName`]: file?.name
    });

    if (!fileControl) return;

    fileControl.markAsTouched();
    fileControl.setErrors(null);

    if (!file) {
      fileControl.setValue(null);
      return;
    }

    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!allowedTypes.includes(file.type)) {
      fileControl.setErrors({ invalidType: true });
      return;
    }

    if (file.size > maxSize) {
      fileControl.setErrors({ maxSize: true });
      return;
    }

    fileControl.updateValueAndValidity();
    this.uploadOtherAttachment(key);
  }

  /**
   * Uploads an "Other Attachment" against the application under review. Every
   * row is saved under the shared 'OtherAttachments' category_name and is told
   * apart by its index in responseValue, so the row can be matched back on
   * reload.
   */
  async uploadOtherAttachment(key: string): Promise<void> {
    const file = this.dsuassessmentForm.get(key)?.value;
    if (!(file instanceof Blob)) {
      return;
    }

    this.setSprinner.set(true);
    let uploadOtherAttachments = new OnboardingAssesmentModel();
    uploadOtherAttachments.setOnboardingid(this.viewId);
    uploadOtherAttachments.setupdatedbyrole(this.sessionStorageService.getCurrentUserRole());
    uploadOtherAttachments.setAttachments([{
      onboardingid: this.viewId,
      docTypeId: 0,
      category_name: this.otherAttachmentDescription,
      fileName: (file as File).name,
      data: await this.convertToBase64(file as File),
      contentType: file.type,
      responseValue: this.otherAttachmentIndex(key)
    }]);

    const responseData = await this.documentUploadService
      .saveOnboardingassessment(uploadOtherAttachments)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      this.snackBarService.openSuccessSnackBar("document uploaded successfully!");
      // Awaited so the row has the saved document's id behind it before the user
      // can act on it - deleting a file uploaded moments earlier would otherwise
      // find no match and clear the field without removing anything.
      await this.loadOtherAttachments();
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  showPreview = false;

  async previewAttachment(controlName: string, filename: string) {
    this.selectedItemFile = controlName;
    await this.loadOtherFile(controlName, filename);
    this.showPreview = true;

  }

  private findAttachment(fileVar: string): OnboardingAssesment | undefined {
    const matches = this.otherAttachmentDocuments?.filter(item => this.otherAttachmentIndexOf(item) === this.otherAttachmentRow(fileVar))
    return matches?.[matches.length - 1];
  }

  async loadOtherFile(category: string, filename: string) {
    const documentId = this.findAttachment(category)?.id;

    if (documentId) {
      try {

        const responseData = await this.documentUploadService
          .viewChecklistdocuments(documentId);

        // Create blob URL
        const fileURL = URL.createObjectURL(responseData);


        // Safe URL
        this.selectedDocument =
          this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);

      } catch (error) {
        console.error(error);
      }
      this.isPdf = this.dsuassessmentForm.get(filename)?.value.toLowerCase().endsWith('.pdf');
      this.currentFileName = this.dsuassessmentForm.get(filename)?.value;
      this.resetZoom();
    }
  }

  zoomIn(): void {
    this.zoomLevel = Math.min(this.MAX_ZOOM, +(this.zoomLevel + this.ZOOM_STEP).toFixed(2));
  }

  zoomOut(): void {
    this.zoomLevel = Math.max(this.MIN_ZOOM, +(this.zoomLevel - this.ZOOM_STEP).toFixed(2));
  }

  resetZoom(): void {
    this.zoomLevel = 1;
  }

  closePreview() {
    this.showPreview = false;
    this.resetZoom();
  }

  convertToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        const result = reader.result as string;

        // Remove metadata prefix
        const base64 = result.split(',')[1];

        resolve(base64);
      };

      reader.onerror = (error) => reject(error);
    });
  }

  async viewDsuAssessment() {
    this.setSprinner.set(true);
    let status = this.data.status;
    const responseData = await this.dsuAssessmentService
      .viewDsuAssessment(this.viewId, status)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);

    if (responseData.status === HttpStatusCode.Ok) {

      this.viewdsuAssessment = responseData.data.responsedata;

      this.dsuassessmentForm.controls['name'].setValue(this.viewdsuAssessment.declaration_details.fullNameNric);
      this.dsuassessmentForm.controls['manager'].setValue(this.viewdsuAssessment.declaration_details.finacialServiceMan);
      this.dsuassessmentForm.controls['initialremarks'].setValue(this.viewdsuAssessment?.remark_details[0]?.remarkContent);
      this.dsuassessmentForm.controls['initialdeclarationaccepted'].setValue(this.viewdsuAssessment.declaration_details.dsuIsAgree);
      this.dsuassessmentForm.controls['corporateMailAddress'].setValue(this.viewdsuAssessment.declaration_details.corporateEmailAddress);
      this.dsuassessmentForm.controls['initialdsuname'].setValue(this.viewdsuAssessment.declaration_details.dsuName);
      this.dsuassessmentForm.controls['initialdate'].setValue(this.viewdsuAssessment.declaration_details.dsuDeclarationDate?.split('T')[0]);
      if (status === 'DSU Final Assessment') {
        this.dsuassessmentForm.controls['initialremarks'].disable();
        this.dsuassessmentForm.controls['initialdeclarationaccepted'].disable();
        if (!['Introducer - Individual', 'Introducer - Corporate'].includes(this.designation)) {
          this.dsuassessmentForm.get('corporateMailAddress')?.setValidators([Validators.required, Validators.email]);
          this.dsuassessmentForm.get('corporateMailAddress')?.updateValueAndValidity();
        }
      }
      if (['Introducer - Individual', 'Introducer - Corporate'].includes(this.designation)) {
        this.dsuassessmentForm.controls['finalremarks'].setValue(this.viewdsuAssessment?.remark_details[0]?.remarkContent);
      } else {
        this.dsuassessmentForm.controls['finalremarks'].setValue(this.viewdsuAssessment?.remark_details[1]?.remarkContent);
      }
      this.dsuassessmentForm.controls['finaldeclarationaccepted'].setValue(this.viewdsuAssessment.declaration_details.isDsuFinalAssessment);
      this.dsuassessmentForm.controls['finaldsuname'].setValue(this.viewdsuAssessment.declaration_details.dsuFinalAssessmentName);
      this.dsuassessmentForm.controls['finaldate'].setValue(this.viewdsuAssessment.declaration_details.dsuFinalAssessmentDate?.split('T')[0]);

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  async getChecklistItems() {
    const responseData = await this.newRepChecklistService
      .getChecklistItems(this.viewId)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });


    if (responseData.status === HttpStatusCode.Ok) {

      this.getchecklistItems = responseData.data.responsedata;
      if (['Introducer - Individual', 'Introducer - Corporate'].includes(this.designation)) {
        this.checklistinvalidflag.set(
          this.getchecklistItems.length === 0 ||
          this.getchecklistItems
            .some(x => x.isCompleted == null || x.isCompleted == false)
        );
      } else {
        this.getchecklistItems = this.getchecklistItems.filter(
          x => x.categoryName.startsWith('minimumDocumentCheck_') || x.categoryName.startsWith('subsequentDocumentsCheck_')
        );
        const preferredOrder = [
          "minimumDocumentCheck_",
          "subsequentDocumentsCheck_",
        ];

        const getCategoryOrder = (categoryName = "") => {
          const index = preferredOrder.findIndex(prefix =>
            categoryName.startsWith(prefix)
          );
          return index === -1 ? preferredOrder.length : index;
        };

        const getSuffixNumber = (categoryName = "") => {
          const match = categoryName.match(/_(\d+)$/);
          return match ? Number(match[1]) : Number.MAX_SAFE_INTEGER;
        };

        this.getchecklistItems.sort((a, b) => {
          const orderA = getCategoryOrder(a.categoryName);
          const orderB = getCategoryOrder(b.categoryName);

          if (orderA !== orderB) {
            return orderA - orderB;
          }

          return getSuffixNumber(a.categoryName) - getSuffixNumber(b.categoryName);
        });
        this.checklistinvalidflag.set(
          this.getchecklistItems.filter(
            x => x.categoryName?.startsWith('minimumDocumentCheck_')
          ).length === 0 ||
          this.getchecklistItems
            .filter(x => x.categoryName?.startsWith('minimumDocumentCheck_'))
            .some(x => x.isCompleted == null || x.isCompleted == false)
        );
      }
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  openConfirmDialog() {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Are you sure you want to submit this Application?',
        hidecancel: false,
      }
    });
    this.getChecklistItems();
    dialogRef.afterClosed().subscribe(result => {
      if (result.data === true) {
        if (this.status == 'DSU Initial Assessment') {
          if (this.dsuassessmentForm.get('initialdeclarationaccepted')?.value == true) {
            if (this.checklistinvalidflag() === true) {
              this.errormessage1 = 'Please complete the checklist';
              this.submitted.set(false);
            } else {
              this.submitted.set(true);
              this.saveAndContinue();
            }
          } else {
            this.errormessage1 = 'Please check the confirm';
            this.submitted.set(false);
          }
        } else if (this.status == 'DSU Final Assessment') {
          if (this.dsuassessmentForm.get('finaldeclarationaccepted')?.value == true) {
            if (this.checklistinvalidflag() === true) {
              this.errormessage2 = 'Please complete the checklist';
              this.submitted.set(false);
            } else {
              this.submitted.set(true);
              this.saveAndContinue();
            }
          } else {
            this.errormessage2 = 'Please check the Confirm';
            this.submitted.set(false);
          }
        }

      } else {
        // console.log('User cancelled');
      }
    });
  }

  async returnByRole() {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to return the application ?',
        hidecancel: false,
      }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result.data === true) {
        this.setSprinner.set(true);
        let saveDsuassessment = new DsuAssessmentModel();
        saveDsuassessment.setOnboardingid(this.viewId);
        saveDsuassessment.setupdatedbyrole(this.sessionStorageService.getCurrentUserRole());
        saveDsuassessment.setRemarkId(this.viewdsuAssessment?.remark_details[0]?.id);
        if (['Introducer - Individual', 'Introducer - Corporate'].includes(this.designation)) {
          saveDsuassessment.setRemarkContent(this.dsuassessmentForm.get('finalremarks')?.value);
          saveDsuassessment.setReturnComments(this.dsuassessmentForm.get('finalremarks')?.value);
        } else {
          saveDsuassessment.setRemarkContent(this.dsuassessmentForm.get('initialremarks')?.value);
          saveDsuassessment.setReturnComments(this.dsuassessmentForm.get('initialremarks')?.value);
        }

        saveDsuassessment.setIs_completed(false);

        const responseData = await this.dsuAssessmentService
          .saveDsuAssessment(saveDsuassessment)
          .then((response) => {
            return JSON.parse(response);
          })
          .catch((error) => {
            // console.error(error);
            return error;
          });

        if (responseData.status === HttpStatusCode.Ok) {
          let returndata = {
            id: this.viewId,
            status: 'Candidate Update (Assessment)',
            return_comments: saveDsuassessment.getReturnComments(),
          };

          const responseData = await this.returnbyroleService
            .statusreturn(returndata)
            .then((response) => {
              return JSON.parse(response);
            })
            .catch((error) => {
              // console.error(error);
              return error;
            });
          this.setSprinner.set(false);
          if (responseData.status === HttpStatusCode.Ok) {
            this.snackBarService.openSuccessSnackBar("Application returned successfully!");
            this.router.navigate(['/agent-onboarding']);

          } else {
            if (responseData.code === HttpStatusCode.BadRequest) {
              // Display notification on API failure.
              this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
            }
            if (responseData.code === HttpStatusCode.Unauthorized) {
              this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
              this.router.navigate(['/login']);
            }
          }
        } else {
          if (responseData.code === HttpStatusCode.BadRequest) {
            // Display notification on API failure.
            this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
          }
          if (responseData.code === HttpStatusCode.Unauthorized) {
            this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
            this.router.navigate(['/login']);
          }
        }
      } else {
        // console.log('User cancelled');
      }
    });

  }

  async saveAndContinue() {
    this.setSprinner.set(true);
    let saveDsuassessment = new DsuAssessmentModel();
    saveDsuassessment.setOnboardingid(this.viewId);
    saveDsuassessment.setupdatedbyrole(this.sessionStorageService.getCurrentUserRole());
    if (this.status == 'DSU Initial Assessment') {
      saveDsuassessment.setRemarkId(this.viewdsuAssessment?.remark_details[0]?.id);
      saveDsuassessment.setRemarkContent(this.dsuassessmentForm.get('initialremarks')?.value);
      if (this.submitted() === true) {
        saveDsuassessment.setIs_completed(this.dsuassessmentForm.get('initialdeclarationaccepted')?.value);
        saveDsuassessment.setDsuName(this.dsuassessmentForm.get('initialdsuname')?.value);
        saveDsuassessment.setDeclaration_date(this.dsuassessmentForm.get('initialdate')?.value + 'T00:00:00Z');
      } else {
        saveDsuassessment.setIs_completed(false);
      }
    } else {
      if (['Introducer - Individual', 'Introducer - Corporate'].includes(this.designation)) {
        saveDsuassessment.setRemarkId(this.viewdsuAssessment?.remark_details[0]?.id);
        saveDsuassessment.setRemarkContent(this.dsuassessmentForm.get('finalremarks')?.value);
      } else {
        saveDsuassessment.setRemarkId(this.viewdsuAssessment?.remark_details[1]?.id);
        saveDsuassessment.setRemarkContent(this.dsuassessmentForm.get('finalremarks')?.value);
      }
      saveDsuassessment.setCorporatEmailAddress(this.dsuassessmentForm.get('corporateMailAddress')?.value);
      if (this.submitted() === true) {
        saveDsuassessment.setIs_completed(this.dsuassessmentForm.get('finaldeclarationaccepted')?.value);
        saveDsuassessment.setDsuName(this.dsuassessmentForm.get('finaldsuname')?.value);
        saveDsuassessment.setDeclaration_date(this.dsuassessmentForm.get('finaldate')?.value + 'T00:00:00Z');
      } else {
        saveDsuassessment.setIs_completed(false);
      }
    }

    const responseData = await this.dsuAssessmentService
      .saveDsuAssessment(saveDsuassessment)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      this.viewDsuAssessment();
      if (this.submitted() == true) {
        this.snackBarService.openSuccessSnackBar("Application submitted successfully!");
        this.router.navigate(['/agent-onboarding']);
      } else {
        this.snackBarService.openSuccessSnackBar("Application saved successfully!");
      }
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }

  }

}
